/**
 * Status labels for the warehouse side of a PO. The canonical 'received' is
 * the buyer's terminal state, so it's spelled out as "Received by buyer"
 * rather than shown as a bare "Received" on a warehouse that received nothing.
 * Shared by the Warehouse Orders / Outgoing lists and the owner PO view so the
 * badge always matches the status filter.
 */
export const WAREHOUSE_STATUS_LABELS: Record<string, string> = {
  sent: 'In Progress',
  received: 'Received by buyer',
  completed: 'Fulfilled',
};
